import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';

import { NotificationsModule } from '../notifications/notifications.module';
import { ImagesModule } from '../images/images.module';
import { ButtonModule } from '../buttons/button.module';
import { ProductCardComponent } from './product-card/product-card.component';
import { BadgesModule } from '../badges';

@NgModule({
  declarations: [ProductCardComponent],
  imports: [CommonModule, ImagesModule, ButtonModule, NotificationsModule, BadgesModule, UiTranslateModule],
  exports: [ProductCardComponent],
})
export class ProductsModule {}
